import { NavLink } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { House, LogOut } from "lucide-react";

interface SidebarFooterProps {
	/**
	 * Called after the "Back to Mee" link is activated. The mobile drawer passes
	 * this to close itself on navigation (matching how its nav items behave); the
	 * persistent desktop sidebar omits it.
	 */
	onNavigate?: () => void;
}

// Neutral footer rows (grey hover), deliberately distinct from the blue,
// link-tinted primary nav rows in NavItems — "Back to Mee" and "Sign out" read
// as chrome/utility actions, not admin destinations.
const rowClass =
	"flex w-full items-center gap-3 rounded-lg px-3 py-2 text-body transition-all duration-150 hover:bg-accent active:scale-[0.98]";

/**
 * Shared footer pinned to the bottom of the admin navigation, rendered by both
 * the desktop {@link Sidebar} and the {@link MobileDrawer} so the two stay
 * identical. Holds a link back to the consumer web front end ("Back to Mee",
 * the reverse of the cog in the consumer TopNav that opens `/admin`) above the
 * Sign out button.
 */
export function SidebarFooter({ onNavigate }: SidebarFooterProps) {
	const { instance } = useMsal();

	return (
		<div className="border-t border-border px-4 py-4 space-y-1">
			<NavLink to="/" end onClick={onNavigate} className={rowClass}>
				<House
					className="h-5 w-5 shrink-0 text-muted-foreground"
					aria-hidden="true"
				/>
				<span>Back to Mee</span>
			</NavLink>
			<button onClick={() => instance.logoutRedirect()} className={rowClass}>
				<LogOut
					className="h-5 w-5 shrink-0 text-muted-foreground"
					aria-hidden="true"
				/>
				<span>Sign out</span>
			</button>
		</div>
	);
}
